"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveTrackerWS = void 0;
const schema_1 = require("@tenderd/schema");
class LiveTrackerWS {
    constructor(geo) {
        this.ws = undefined;
        this.ids = [];
        this.listener = () => { };
        this.id = 'test';
        this.geo = geo || schema_1.Geo.UAE;
    }
    setLiveIds(ids) {
        this.ids = ids;
    }
    open() {
        if (this.ws) {
            this.ws.killed = true;
            this.ws.close();
            this.ws = undefined;
        }
        if (this.ids.length == 0) {
            return;
        }
        const ws = new WebSocket("wss://api.tenderd.com/live_tracking");
        ws.onopen = () => {
            if (ws) {
                ws.send(JSON.stringify({ type: "REGISTER", id: this.id, geo: this.geo }));
                ws.send(JSON.stringify({ type: "LISTEN_DEVICE", deviceIds: this.ids, geo: this.geo }));
            }
        };
        ws.onmessage = evt => {
            const data = JSON.parse(evt.data.toString());
            this.listener(data);
        };
        ws.onclose = () => {
            if (ws) {
                console.log('killed: ', ws.killed);
                if (!ws.killed) {
                    setTimeout(() => this.open(), 1000);
                }
            }
        };
        ws.onerror = (reason) => {
            console.error(reason);
            console.error("Websocket error: " + reason.toString());
        };
        this.ws = ws;
    }
    start(id, listener) {
        this.id = id;
        this.listener = listener;
        if (this.ws && this.ws.readyState === 1) {
            this.ws.send(JSON.stringify({ type: "LISTEN_DEVICE", deviceIds: this.ids, geo: this.geo }));
        }
        else {
            this.open();
        }
    }
    close() {
        if (this.ws) {
            this.ws.killed = true;
            this.ws.close();
        }
    }
}
exports.LiveTrackerWS = LiveTrackerWS;
//# sourceMappingURL=LiveTrackerWS.js.map